// Row component used by the mapping function in StoresTable.js
import React from 'react';
import { MdEdit } from "react-icons/md";

function RollRow({ roll, onEdit, canEdit=false }) {
   // Row label from id
  const rawId = String(roll?.id ?? "").toLowerCase();
  const typeLower = rawId.toLowerCase();
  const type = typeLower.includes("takeoff")
    ? "Takeoff 15°C"
    : typeLower.includes("landing")
    ? "Landing 15°C"
    : rawId;

  const sea = roll?.Sea_Level ?? roll?.Sea_level ?? "";
  const fieldElevation =
  roll?.Field_Elevation ??
  roll?.field_elevation ??
  roll?.["2500MSL"] ??   // fallback for older docs
  "";
  const units = roll?.units ?? "Feet";


    return (
        <tr>
            <td className="item_box">{type}</td>
            <td className="sea_box">{sea}</td>
            <td className="msl_box">{fieldElevation}</td>
            <td className="unit_box">{units}</td>
            {canEdit && (
            <td className="edit_box">
                <MdEdit onClick={() => onEdit?.(roll)} 
                    />
            </td>
            )}
        </tr>
    );
}
export default RollRow;
